if (!customElements.get('live-matchmaker')) {
  customElements.define('live-matchmaker', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-live-matchmaker-form]');
      this.status = this.querySelector('[data-matchmaker-status]');
      this.timer = null;
      this.controller = null;
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.update();
      });
      this.form?.addEventListener('change', () => {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.update(), 120);
      });
      this.querySelector('[data-matchmaker-clear]')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.form.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
        this.update();
      });
      this.bindPagination();
    }

    buildUrl() {
      const url = new URL(this.form.action, window.location.origin);
      const params = new URLSearchParams(new FormData(this.form));
      params.delete('page');
      url.search = params.toString();
      return url;
    }

    async update(requestedUrl) {
      const url = requestedUrl ? new URL(requestedUrl, window.location.origin) : this.buildUrl();
      const results = document.querySelector('[data-matchmaker-results]');
      this.controller?.abort();
      this.controller = new AbortController();
      results?.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Updating matches…';
      try {
        const response = await fetch(url, { signal: this.controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextResults = documentFragment.querySelector('[data-matchmaker-results]');
        if (!nextResults || !results) throw new Error('Matchmaker results were not returned.');
        results.replaceWith(nextResults);
        window.history.replaceState({}, '', url);
        this.status.textContent = nextResults.querySelector('.matchmaker-results-count')?.textContent.trim() || 'Matches updated.';
        this.bindPagination();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = 'Unable to update automatically. Reloading…';
        window.location.assign(url);
      } finally {
        document.querySelector('[data-matchmaker-results]')?.removeAttribute('aria-busy');
      }
    }

    bindPagination() {
      document.querySelectorAll('[data-matchmaker-results] .pagination a').forEach((link) => {
        if (link.dataset.liveBound) return;
        link.dataset.liveBound = 'true';
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.update(link.href).then(() => document.querySelector('[data-matchmaker-results]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        });
      });
    }
  });
}
